import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Divider, Dropdown, Table } from "antd";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import svg12 from "../../../../assets/svg/svg12.svg";
import svg13 from "../../../../assets/svg/svg13.svg";
import svg27 from "../../../../assets/svg/svg27.svg";
import svg29 from "../../../../assets/svg/svg29.svg";
import ConfirmModal from "../../../../components/ConfirmModal";
import Search from "../../../../components/Search";
import useModalToggle from "../../../../custom_hooks/useModalToggle";
import { fetchData } from "../../../../features/fetch/fetchSlice";
import { save } from "../../../../features/save/saveSlice";
import { numberWithCommas } from "../../../../utils";
import VarietyAdd from "./modal/VarietyAdd";


function VarietiesTable({ productionDataId, varieties }) {
  const dispatch = useDispatch();
  const url = "api/v1/production-varieties/list";
  const urlSeason = `${process.env.REACT_APP_API_BASE_ROBOT}/season/fetch_seasons`;
  const urlVariety = `${process.env.REACT_APP_API_BASE_ROBOT}/crop_variety/fetch_cropvarietys`;

  const { loading, data, dataSeason, dataVariety } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    dataSeason: state.fetch.data[urlSeason] || [],
    dataVariety: state.fetch.data[urlVariety] || [],
  }));

  const { open, handleCancel, handleOpen } = useModalToggle();
  const [searchInput, setsearchInput] = useState(null);
  const [prodd, setProdd] = useState();
  const [prodd2, setProdd2] = useState();

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        productionDataId: productionDataId,
        variety: e.target.value == "" ? null : e.target.value,
        start: 0,
        limit: null,
      })
    );
    setPageIndex(0);
  };

  const handleEdit = async () => {
    await handleOpen();
  };

  const handleAdd = async (item) => {
    await setProdd();
    await setProdd2(item);
    await handleOpen();
  };

  const [openDelete, setOpenDelete] = useState(false);
  const handleOpenDelete = () => {
    setOpenDelete(true);
  };
  const handleCloseDelete = () => {
    setOpenDelete(false);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      save({
        url: "api/v1/production-varieties/delete",
        id: prodd?.id,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.message);
      await setOpenDelete(false);
      await fetchTableData();
    } else {
      toast.error(res?.payload?.message);
    }
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <div onClick={handleEdit}>
          <Link className="flex actions-text gap-x-[.75rem] my-2 ">
            <img src={svg12} alt="svg12" /> Edit
          </Link>
          <div className="mt-[1rem]">
            <Divider />
          </div>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div onClick={handleOpenDelete}>
          <Link className="flex items-center gap-x-2 actions-text my-2">
            <img src={svg13} alt="svg13" className="w-4 h-4" />
            <span className="whitespace-nowrap">Delete</span>
          </Link>
        </div>
      ),
    },
  ];

  async function fetchTableData() {
    if (!productionDataId) return;
    await dispatch(
      fetchData({
        url: url,
        limit: 1000,
        start: 0,
        productionDataId: productionDataId,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
    dispatch(
      fetchData({
        url: urlSeason,
        limit: 1000,
        start: 0,
      })
    );
    dispatch(
      fetchData({
        url: urlVariety,
        limit: 1000,
        start: 0,
      })
    );
  }, [productionDataId]);

  const columns = [
    {
      title: "Variety / Season",
      dataIndex: "season",
      render: (_, record, index) => {
        if (record?.isGroup) {
          return {
            children: (
              <div className="flex items-center gap-x-[1.25rem] font-interSans font-[600] text-[1rem] text-[#23262F]">
                <div className="bg-[#D6E1F5] w-[2.25rem] h-[2.25rem] rounded-full flex justify-center items-center ">
                  <span className="text-[#0092CC]">
                    {(() => {
                      let num = 1;
                      for (let i = 0; i < index; i++) {
                        if (groupedData?.[i]?.isGroup) num++;
                      }
                      return num;
                    })()}
                  </span>
                </div>
                {record?.variety?.name}
              </div>
            ),
            props: { colSpan: 3 },
          };
        }
        return record?.season?.name;
      },
    },
    {
      title: "Acreage Under Irrigation",
      dataIndex: "acreage",
      align: "right",
      render: (text, record) =>
        record?.isGroup
          ? { props: { colSpan: 0 } }
          : numberWithCommas(text ?? 0),
    },
    {
      title: "Production (Tonnes)",
      dataIndex: "production",
      align: "right",
      render: (text, record) =>
        record?.isGroup
          ? { props: { colSpan: 0 } }
          : numberWithCommas(text ?? 0),
    },
    {
      title: (
        <div>
          <div>Productivity (Kg/Acre)</div>
          <div className="proj_desc !font-[400]">
            (Production &times; 1,000) &divide; Acreage
          </div>
        </div>
      ),
      dataIndex: "averageProductionPerAcre",
      align: "right",
      render: (text, record) =>
        record?.isGroup
          ? record?.averageProductionPerAcre
          : numberWithCommas(text ?? 0),
    },
    {
      title: "Farm Gate Price (KES/Kg)",
      dataIndex: "farmGatePrice",
      align: "right",
      render: (text, record) =>
        record?.isGroup ? record?.farmGatePrice : numberWithCommas(text ?? 0),
    },
    {
      title: (
        <div>
          <div>Revenue per Acre (KES)</div>
          <div className="proj_desc !font-[400]">
            Productivity &times; Farm Gate Price
          </div>
        </div>
      ),
      dataIndex: "revenuePerAcre",
      align: "right",
      render: (text, record) =>
        record?.isGroup
          ? record?.revenuePerAcre
          : numberWithCommas(text ?? 0),
    },
    {
      title: "Cost of Prod. per Acre (KES)",
      dataIndex: "costPerAcre",
      align: "right",
      render: (text, record) =>
        record?.isGroup ? record?.costPerAcre : numberWithCommas(text ?? 0),
    },
    {
      title: "Water Requirement (m3/s)",
      dataIndex: "waterRequirement",
      align: "right",
      render: (text, record) => (record?.isGroup ? record?.waterRequirement : text),
    },
    {
      title: "Available Water Flow (m3/s)",
      dataIndex: "availableFlow",
      align: "right",
      render: (text, record) => (record?.isGroup ? record?.availableFlow : text),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => {
        if (record?.isGroup) {
          return {
            children: (
              <button
                onClick={() => handleAdd(record)}
                type="button"
                className="bg-[#0092CC] flex items-center justify-center p-[.5rem] rounded-[.375rem]"
              >
                <img src={svg29} alt="svg29" />
              </button>
            ),
            props: { colSpan: 1 },
          };
        }
        return (
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button type="button" onClick={() => setProdd(record)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        );
      },
    },
  ];

  // Group rows by variety - the parents come from the varieties picked on step 1
  // plus any variety already carrying rows.
  const groupDataByVariety = (rows) => {
    const parents = [];
    const seen = new Set();
    [
      ...(varieties ?? []),
      ...(rows?.map((item) => item?.variety) ?? []),
    ]?.forEach((item) => {
      if (item?.id && !seen.has(item?.id)) {
        seen.add(item?.id);
        // The record may hold a null label, so fall back to the setup list
        parents.push({
          id: item?.id,
          name:
            item?.name ??
            dataVariety?.find((crop) => crop?.cvId === item?.id)?.cvVariety ??
            null,
        });
      }
    });

    return parents?.map((variety) => ({
      parent: { isGroup: true, variety: variety },
      children: rows?.filter((item) => item?.variety?.id === variety?.id) ?? [],
    }));
  };

  const groups = groupDataByVariety(data);
  const pagedGroups = groups.slice(
    pageIndex * pageSize,
    (pageIndex + 1) * pageSize
  );
  const groupedData = pagedGroups.flatMap(({ parent, children }) => [
    parent,
    ...children,
  ]);

  return (
    <>
      <div className="flex flex-col w-full  flex-1">
        <div className="flex lg:flex-row flex-col lg:items-center justify-between  gap-y-4">
        <div className="flex flex-col">
          <div className="custom-title !text-[#111928] !bg-white !p-0 !mb-0">Production Data</div>
          <div className="proj_desc mt-[.5rem]">
          Pick the production data above, then use the + on each variety to capture
          its seasons.
        </div></div>
          <div className="flex flex-wrap items-center lg:justify-end justify-start gap-[.62rem]">
            <div className="lg:w-[16.125rem] w-full  ">
              <Search
                searchInput={searchInput}
                handleSearch={handleSearch}
                text={"Search"}
              />
            </div>
          </div>
        </div>

       

        <Table
          rowClassName={(record) => (record?.isGroup ? "" : "")}
          rowSelection={false}
          bordered={false}
          pagination={{
            position: ["bottomRight"],
            current: pageIndex + 1,
            total: groups.length,
            pageSize: pageSize,
            onChange: (page, size) => {
              setPageIndex(page - 1);
              setPageSize(size);
            },
            showSizeChanger: false,
            hideOnSinglePage: true,
          }}
          columns={columns}
          dataSource={groupedData}
          summary={() => {
            const totalProduction = groupedData
              ?.filter((item) => !item?.isGroup)
              ?.reduce(
                (sum, item) => sum + (parseFloat(item?.production) || 0),
                0
              );
            return (
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={2}>
                  <span className="font-bold">Total</span>
                </Table.Summary.Cell>
                <Table.Summary.Cell align="right">
                  <span className="font-bold">
                    {numberWithCommas(totalProduction ?? 0)}
                  </span>
                </Table.Summary.Cell>
                <Table.Summary.Cell colSpan={7} />
              </Table.Summary.Row>
            );
          }}
          scroll={{
            x: "auto",
          }}
          className="mt-[1.94rem] "
          loading={loading}
        />
      </div>

      <VarietyAdd
        isModalOpen={open}
        handleCancel={handleCancel}
        handleFetch={fetchTableData}
        prodd={prodd}
        prodd2={prodd2}
        productionDataId={productionDataId}
        dataSeason={dataSeason}
      />

      <ConfirmModal
        open={openDelete}
        handleCancel={handleCloseDelete}
        handleSubmit={handleDelete}
        loading={loading}
        content={`Are you sure you want to delete ${
          prodd?.season?.name ?? "this season"
        }${prodd?.variety?.name ? ` for ${prodd?.variety?.name}` : ""}?`}
        type="alert"
        btnTitle="Delete"
      />
    </>
  );
}

export default VarietiesTable;
